<template>
  <VueTimepicker
    format="HH:mm"
    :minute-interval="5"
    @input="updateValue"
    :value=time
  ></VueTimepicker>
</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
  components: {
    VueTimepicker,
  },
  props: {
    value: {

    }
  },
  computed: {
    date() {
      return ''
    },
    time() {
      return this.value
    }
  },
  methods: {
    updateValue: function(e) {
      this.$emit("input", e);
    }
  }
}

</script>